<template>
    <div class="landlord-authorization">
    <!-- <div class="landlord-authorization" v-if="addContractVersionMode === 'ESCROW' || editContractVersionMode === 'ESCROW'"> -->
        <div class="image-cover">
            <label class="button-font input-label">
                <div class="title">
                    <span class="must-fill"></span>
                    房東委託授權書
                </div>
                <span v-show="error.landlordAuthorization" class="error-with-title">{{error.landlordAuthorization}}</span>
            </label>
            <div class="input-arear">
                <div v-if="isEdit && landlordAuthorization.length == 0 && !houseDefault.attorneyFileName || !isEdit && landlordAuthorization.length == 0" class="cover-block" :class="{'img-error': error.landlordAuthorization}">
                    <file-upload
                    class="upload-btn"
                    post-action="/upload/post"
                    input-id="authorization"
                    :size="1024 * 5"
                    :maximum="1"
                    :multiple="true"
                    v-model="landlordAuthorization"
                    @input-file="inputFile"
                    @input-filter="inputFilter"
                    ref="uploadCover">
                        <img class="upload-icon" src="@/assets/img/icon/upload_biz.svg" alt="">
                        上傳PDF
                    </file-upload>
                </div>
                <div v-else class="cover-preview">
                    <div class="preview">
                        <span v-if="landlordAuthorization.length && landlordAuthorization[0].type == 'application/pdf'">
                            {{landlordAuthorization[0].name}}
                        </span>
                        <span v-else-if="houseDefault.attorneyFileName" style="cursor: pointer;" @click="getAttorneyUrl">
                            {{houseDefault.attorneyFileName}}
                        </span>
                    </div>
                    <file-upload
                        class="replace"
                        post-action="/upload/post"
                        input-id="authorization"
                        :size="1024 * 5"
                        :maximum="1"
                        :multiple="true"
                        :drop="true"
                        :drop-directory="true"
                        v-model="landlordAuthorization"
                        @input-file="inputFile"
                        @input-filter="inputFilter"
                        ref="uploadCover">
                            取代文件
                    </file-upload>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import FileUpload from 'vue-upload-component';
import { mapGetters } from 'vuex'
import { 
    getHouseAttorney
} from "@/apis/company/houseMgt.js"; 
export default {
    data () {
        return {
            landlordAuthorization: [],
            attorney: null,
            error: {
                landlordAuthorization: null
            }
        }
    },
    props: {
        isEdit:{
            type: Boolean,
            default: false
        }
    },
    created() {
        // this.getAttorneyUrl()
    },
    watch: {
        landlordAuthorization: function (val){
            if(this.isEdit){
                this.$store.dispatch('setBizEditLandlordAuth', val)
            }else{
                this.$store.dispatch('setBizLandlordAuth', val)
            }
        },
    },
    methods: {
        getAttorneyUrl: function () {
            const params = {
                houseCid: this.$route.query.cid
            }
            getHouseAttorney(params)
            .then(res => {
                console.log(res)
                if( res.status == 200 ){
                   this.attorney = res.data
                   const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf;charset-UTF-8' }));
                    window.open(url);
                }
            })
            .catch(err => {
            })
        },
        inputFile: function (newFile, oldFile) {
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // Get response data
                if (newFile.xhr) {
                //  Get the response status code
                // console.log('status', newFile.xhr.status)
                }
            }
        },
        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                // if (!/\.(jpeg|jpe|jpg|png|pdf)$/i.test(newFile.name)) {
                //     return prevent()
                // }else 
                if (/\.(pdf)$/i.test(newFile.name)) {
                    this.landlordAuthorizationType = 'pdf'
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '請上傳PDF檔案',type: 'error'})
                    return prevent()
                }
                if(newFile.size > (1024*1024*10)){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '檔案最大限制10MB',type: 'error'})
                    return prevent()
                }
                // else if(/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)){
                //     this.landlordAuthorizationType = 'image'
                // }
            }
            
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
    },
    computed: {
        ...mapGetters({
            houseDefault: 'GET_BIZ_EDIT_HOUSE_DEFAULT',
            addContractVersionMode: 'GET_BIZ_CONTRACT_VERSION_MODE',
            editContractVersionMode: 'GET_BIZ_EDIT_CONTRACT_VERSION_MODE'
        })
    },
    components: {
        FileUpload,
    }
}
</script>
<style lang="scss" scoped>
.landlord-authorization{
    display: flex;
    align-items: center;
    .image-cover{
        .cover-block{
            position: relative;
            width: 124px;
            height: 93px;
            border-radius: 4px;
            border: dashed 1px #cacfcd;
            background-color: #ffffff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            img{
                width: 24px;
                margin-bottom: 4px;
            }
            .upload-btn{
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
            }
            .img-error{
                position: absolute;
                width: 200px;
                left: 136px;
                font-weight: 500;
                font-size: 12px;
                color:  #F05A3E;
                top: unset;
            }
        }
        .cover-block.img-error{
            border: dashed 1px #F05A3E;
        }
        .cover-preview{
            display: flex;
            align-items: center;
            .preview{
                display: flex;
                margin-right: 8px;
                align-items: center;
                color: #ff9275;
                text-decoration: underline;
            }
            .replace{
                width: 104px;
                height: 44px;
                border-radius: 4px;
                border: solid 1px #e0dfde;
                background: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseMgt/addHouse/uploadLandlordAuthorization.vue